import { takeLatest, put, call } from "redux-saga/effects";
import authActions from "../actions/authActions";
import HttpService from "../../services/httpServices/httpServices";
import typeMessage from "../../messages/type";

const userEnterMobileForLoginWorker = function* (action) {
  const mobile = action.payload;
  try {
    const resulat = yield call(() => {
      const bodyPost = {
        mobile: mobile,
      };

      const url =
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/enter-mobile-for-login";

      return HttpService.postRequest(url, bodyPost);
    });

    yield put({
      type: authActions.USER_ENTER_MOBILE_FOR_LOGIN_SUCCESS,
      payload: mobile,
    });
  } catch (error) {
    yield put({
      type: authActions.USER_ENTER_MOBILE_FOR_LOGIN_FAILED,
      payload: {
        hasError: true,
        typeMessage: typeMessage.ERROR,
        message: error.response.data.message,
      },
    });
  }
};

export const userEnterMobileForLoginWatcher = function* () {
  yield takeLatest(
    authActions.USER_ENTER_MOBILE_FOR_LOGIN,
    userEnterMobileForLoginWorker
  );
};

const checkSmsCodeMobileForLoginWorker = function* (action) {
  const smsCode = action.payload.smsCode;
  const mobile = action.payload.mobile;

  try {
    const resulat = yield call(() => {
      const bodyPost = {
        login_code: smsCode,
        mobile: mobile,
      };
      const url =
        process.env.REACT_APP_DOMAIN_API + "/v1/auth/login-with-mobile";

      return HttpService.postRequest(url, bodyPost);
    });

    localStorage.setItem("token", resulat.data.data);

    yield put({
      type: authActions.CHECK_SMS_CODE_MOBILE_FOR_LOGIN_SUCCESS,
      payload: null,
    });

    const url = process.env.REACT_APP_DOMAIN;
    window.location.replace(url);
  } catch (error) {
    yield put({
      type: authActions.CHECK_SMS_CODE_MOBILE_FOR_LOGIN_FAILED,
      payload: {
        hasError: true,
        typeMessage: typeMessage.ERROR,
        message: error.response.data.message,
      },
    });
  }
};

export const checkSmsCodeMobileForLoginWatcher = function* () {
  yield takeLatest(
    authActions.CHECK_SMS_CODE_MOBILE_FOR_LOGIN,
    checkSmsCodeMobileForLoginWorker
  );
};

const checkUserLoginWorker = function* () {
  try {
    const resulat = yield call(() => {
      const url = process.env.REACT_APP_DOMAIN_API + "/v1/auth/init";
      const token = localStorage.getItem("token");

      const headersRequest = {
        headers: {
          authorization: `Bearer ${token}`,
        },
      };

      return HttpService.getRequest(url, headersRequest);
    });

    yield put({
      type: authActions.CHECK_USER_LOGIN_SUCCESS,
      payload: resulat.data.data,
    });
  } catch (error) {
    yield put({
      type: authActions.CHECK_USER_LOGIN_FAILED,
      payload: null,
    });
  }
};

export const checkUserLoginWatcher = function* () {
  yield takeLatest(authActions.CHECK_USER_LOGIN, checkUserLoginWorker);
};

const registerUserWorker = function* (action) {
  try {
    const resulat = yield call(() => {
      const url = process.env.REACT_APP_DOMAIN_API + "/v1/auth/register";
      const headersRequest = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      return HttpService.postRequest(url, action.payload, headersRequest);
    });

    yield put({
      type: authActions.USER_REGISTER_SUCCESS,
      payload: resulat.data.data,
    });
  } catch (error) {
    yield put({
      type: authActions.USER_REGISTER_FAILED,
      payload: null,
    });
  }
};

export const registerUserWatcher = function* () {
  yield takeLatest(authActions.USER_REGISTER, registerUserWorker);
};
